import { render, staticRenderFns } from "./description_renderer.vue?vue&type=template&id=0d27636e&scoped=true&"
import script from "./description_renderer.vue?vue&type=script&lang=ts&"
export * from "./description_renderer.vue?vue&type=script&lang=ts&"
import style0 from "./description_renderer.vue?vue&type=style&index=0&id=0d27636e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d27636e",
  null
  
)

export default component.exports